export default __webpack_public_path__ + "media/logo.f518432caf760477be5e0afcf5fa598e.webp";